// const Home = () => import( /* webpackChunkName: "home" */ './Home.vue');
const About = () => import( /* webpackChunkName: "about" */ './views/About.vue');
const Search = () => import( /* webpackChunkName: "search" */ './views/Search.vue');
const CoNet = () => import( /* webpackChunkName: "network" */ './views/CoNet.vue');
const WVNet = () => import( /* webpackChunkName: "network" */ './views/WVNet.vue');
const NotFound = () => import( /* webpackChunkName: "notfound" */ './views/NotFound.vue');

export const routes = [
  {
    path: '/',
    // name: 'Home',
    redirect: { name: 'Search' }
  },
  {
    path: '/search',
    name: 'Search',
    component: Search
  },
  {
    path: '/co-net',
    name: 'CoNet',
    component: CoNet
  },
  {
    path: '/wv-net',
    name: 'WVNet',
    component: WVNet
  }, 
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: About
  },
  // Separated into two routes so that you can also programmatically
  // direct the user to the /404 if missing some data, etc.
  { 
    path: '/404', 
    name: 'NotFound',
    component: NotFound 
  },
  { 
    path: '*', 
    redirect: to => { return {'name': 'NotFound'} }
  }
]



